import { UPDATE_ALL_STATUS_CONSTANTS } from '../constants';

const updateAllStatus = (state, action) => {
    if (state === undefined) {
        return {
            data: {},
            loading: false,
            error: null,
            success: false,
        };
    }

    switch (action.type) {
        case UPDATE_ALL_STATUS_CONSTANTS.UPDATE_ALL_STATUS_REQUEST:
            return {
                data: {},
                loading: true,
                error: null,
                success: false,
            };

        case UPDATE_ALL_STATUS_CONSTANTS.UPDATE_ALL_STATUS_SUCCESS:
            return {
                data: action.payload,
                loading: false,
                error: null,
                success: true,
            };

        case UPDATE_ALL_STATUS_CONSTANTS.UPDATE_ALL_STATUS_FAILURE:
            return {
                data: {},
                loading: false,
                error: action.payload,
                success: false,
            };

        default:
            return state;
    }
};

export default updateAllStatus;
